import React from 'react';
import { Alert } from '30pay/components';
import { ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import ProfileVerify from './verify/verify.index';
import ProfileInfo from './info/info';
import ProfileCredential from './credential/credential.index';
import { Notifications } from './notifications/notifications.index';

const Profile: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    return (
        <div className="p-4 w-full h-full flex flex-col">
            {props.user?.level.uniqueName.id === 1 && (
                <Alert
                    className="mb-2"
                    variant="warning"
                    message="برای برداشت ارزی می‌بایست اقدام به تکمیل احراز هویت کنید."
                />
            )}
            <ProfileVerify />
            <div className="flex gap-4 mt-6 max-lg:flex-col max-lg:mt-4">
                <ProfileInfo />
                <ProfileCredential />
            </div>
            <Notifications />
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Profile);
